import { disputesApi } from "../store/api/disputesApi";
import { runMutation, runQuery, runQueryNoArg } from "../store/api/runtime";

type JsonValue = Record<string, unknown> | unknown[];

export const createDispute = async (disputeData: Record<string, unknown>): Promise<unknown> =>
  runMutation(disputesApi.endpoints.createDispute.initiate, disputeData);

export const getBuyerDisputes = async (buyerId: string): Promise<unknown> =>
  runQuery(disputesApi.endpoints.getBuyerDisputes.initiate, buyerId);

export const getSellerDisputes = async (sellerId: string): Promise<unknown> =>
  runQuery(disputesApi.endpoints.getSellerDisputes.initiate, sellerId);

export const getDisputeById = async (disputeId: string): Promise<unknown> =>
  runQuery(disputesApi.endpoints.getDisputeById.initiate, disputeId);

export const respondToDispute = async (
  disputeId: string,
  response: string,
  evidence: JsonValue[] = [],
): Promise<unknown> => runMutation(disputesApi.endpoints.respondToDispute.initiate, { disputeId, response, evidence });

export const resolveDispute = async (
  disputeId: string,
  resolution: string,
  refundAmount: number,
  adminNotes: string,
): Promise<unknown> =>
  runMutation(disputesApi.endpoints.resolveDispute.initiate, { disputeId, resolution, refundAmount, adminNotes });

export const markDisputeInReview = async (disputeId: string, adminNotes = ""): Promise<unknown> =>
  runMutation(disputesApi.endpoints.markDisputeInReview.initiate, { disputeId, adminNotes });

export const getAllDisputes = async (): Promise<unknown> =>
  runQueryNoArg(disputesApi.endpoints.getAllDisputes.initiate);
